import { useState } from 'react';
import '../styles/common.css';
import img_base from '../assets/images/exp/2.webp';
import img_sun from '../assets/images/app/sun.webp';

interface OPPopProps {
    appId: number;
    popId: number;
    onClose: () => void;
}

export default function OPPop({ appId = 1, popId = 1, onClose }: OPPopProps) {
    const [isSelected, setIsSelected] = useState(false);
    // 阻止弹窗内容区域的点击事件冒泡到遮罩层
    const handlePopupClick = (e: React.MouseEvent) => {
        e.stopPropagation();
    };

    return (
        <div className="overlay ">
            {/* 弹窗内容区域添加点击事件阻止冒泡 */}
            {appId === 1 && (
                <div className="popup" onClick={handlePopupClick}>
                    {!isSelected && (
                        <img
                            src={new URL(`../assets/images/op1/b${popId}.webp`, import.meta.url).href}
                            alt="Popup"
                            style={{ width: '100%', height: 'auto' }}
                        />
                    )}
                    {isSelected && (
                        <img
                            src={new URL(`../assets/images/op2/c${popId}.webp`, import.meta.url).href}
                            alt="Popup"
                            style={{ width: '100%', height: 'auto' }}
                        />
                    )}
                    <div className='absolute h-[5%] w-[5%] top-[16%] right-[21%] flex flex-col cursor-pointer '
                        onClick={onClose}>
                        <span className='text-[#000] text-[1.3vw] text-center'>关闭</span>
                        <span className='text-[#000] text-[1vw] text-center'>Close</span>
                    </div>
                    {!isSelected && (
                        <div className='absolute h-[5%] w-[10%] top-[75%] right-[21%] flex flex-col cursor-pointer '
                            onClick={() => { setIsSelected(true) }}>
                            <span className='text-[#000] text-[1.3vw] text-center'>查看原文</span>
                            <span className='text-[#000] text-[1vw] text-center'>View Original Text</span>
                        </div>
                    )}

                </div>
            )}
            {appId === 2 && (
                <div className="popup" onClick={handlePopupClick}>
                    <img src={img_base} />
                    <img src={img_sun} className='absolute top-[-50%] right-[-30%] w-[60%]' />
                    <div className='absolute h-[5%] w-[5%] top-[10%] left-[10%] flex flex-col cursor-pointer '
                        onClick={onClose}>
                        <span className='text-[#fff] text-[1.3vw] text-center'>返回</span>
                        <span className='text-[#fff] text-[1vw] text-center'>Back</span>
                    </div>
                    <img
                        src={new URL(`../assets/images/op/a${popId}.webp`, import.meta.url).href}
                        alt="Popup"
                        className='absolute top-[30%] left-[15%] w-[55%]'
                    />
                </div>
            )}
        </div>
    );
}